module.exports = __webpack_public_path__ + "static/media/key.5f2718ee.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/instructions/assets/key.png
 ** module id = 292
 ** module chunks = 0
 **/